<template>
  <div v-if="config" class="scroll-vertical">
    <content-nav-bar>
      <p class="is-size-4 level-item">Config Token</p>
      <template slot="right">
        <p class="level-item is-clickable" @click="doCopy()">{{ message }}</p>
        <svgicon
        class="level-item is-clickable"
        name="copy" width="30" height="30"
        @click="doCopy()"></svgicon>
      </template>
    </content-nav-bar>
    <detail-item
      v-if="config"
      name="Size"
      imgName="circle">
      {{ config.token.length | bytesToSize }}
    </detail-item>
    <detail-item
      v-if="header"
      name="JWT Encryption Algorithm"
      imgName="circle">
      {{ header.alg }}
    </detail-item>
    <detail-item
      v-if="header"
      name="JWT Signing CERT ID"
      imgName="circle">
      {{ header.kid }}
    </detail-item>
    <detail-item
      v-if="payload"
      name="Config ID"
      imgName="circle">
      {{ payload.configId }}
    </detail-item>
    <detail-item
      v-if="payload"
      name="Config Version"
      imgName="circle">
      {{ payload.configVersion }}
    </detail-item>
    <detail-item
      v-if="payload"
      name="Config Hash"
      imgName="circle">
      {{ payload.hash }}
    </detail-item>
    <detail-item
      v-if="payload"
      name="Raw Config"
      imgName="circle"
      :labelTop="true">
      {{ payload.config }}
    </detail-item>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'ProfileJWT',
  components: { DetailItem, ContentNavBar },
  mixins: [gmt],
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    this.config = await this.$store.dispatch('primary/getConfig', { id: this.profile.id });
    this.payload = jwtDecode(this.config.token);
    this.header = jwtDecode(this.config.token, { header: true });
  },
  data() {
    return {
      config: null,
      payload: null,
      header: null,
      message: 'click to copy token',
    };
  },
  methods: {
    doCopy() {
      this.$copyText(this.config.token);
      this.message = 'token copied';
    },
  },
};
</script>

<style lang="scss">
@import '@/scss/colors.scss';

</style>
